import { render, staticRenderFns } from "./groupFitnessDashboardEventForm.vue?vue&type=template&id=7694a648&scoped=true&xmlns=true"
import script from "./groupFitnessDashboardEventForm.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardEventForm.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardEventForm.vue?vue&type=style&index=0&id=7694a648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7694a648",
  null
  
)

export default component.exports